import React, { useEffect, useState } from 'react'
import DashboardLayout from '../../components/layouts/dashboard'
import TabView from '../../components/tabview'
import HRPerformanceOverviewTab from '../../components/performance/performance-overview'
import PerformanceOKRTab from '../../components/performance/okr'
import PerformanceSmartGoalsTab from '../../components/performance/smart-goals'
import TechnicalAppraisalsTab from '../../components/performance/technical-appraisals'
import Button from '../../components/button'
import { useHistory } from 'react-router-dom'
import Evaluations from '../../components/performance/Evaluations'
import Goals from '../../components/performance/Goals'
import Assessment from '../../components/performance/Assessment'

const HRPerformancePage = () => {
  useEffect(() => {
    window.scroll(0, 0)
  }, [])
  const history = useHistory()
  const [activeTab, setActiveTab] = useState(1)
  // const performanceTabs = [
  //   {
  //     title: 'Performance Appraisals',
  //     Content: HRPerformanceOverviewTab,
  //   },
  //   {
  //     title: 'OKR',
  //     Content: PerformanceOKRTab,
  //   },
  //   {
  //     title: 'SMART Goals',
  //     Content: PerformanceSmartGoalsTab,
  //   },
  //   {
  //     title: 'Technical Appraisals',
  //     Content: TechnicalAppraisalsTab,
  //   },
  // ]

  const performanceTabs = [
    {
      title: 'My Goals',
      Content: Goals,
    },
    {
      title: 'Evaluations',
      Content: Evaluations,
    },
    {
      title: 'Assessments',
      Content: Assessment,
    },
  ]

  return (
    <DashboardLayout title='Performance Management'>
      <div className='font-bold text-lg'>Performance Management</div>
      <div className='flex flex-col bg-white rounded-[16px] p-3'>
        <TabView
          Tabs={performanceTabs}
          activeTab={activeTab}
          setActiveTab={setActiveTab}
        />
      </div>
    </DashboardLayout>
  )
}

export default HRPerformancePage
